/**
 * Tracks whether the current Redux scenes state was last populated by the
 * full editor (EditorRoute) vs casual surfaces (landing embedded preview,
 * /free standalone editor).
 *
 * Why: Casual surfaces deliberately preserve existing Redux state so that
 * navigating landing → /free keeps the user's device/background choices.
 * However, when the user leaves the full editor — where they may have
 * picked a non-default device — that state must NOT leak back into the
 * casual editors. Without this flag, the embedded landing editor would
 * keep showing whatever device the user last picked in /editor.
 *
 * The flag is module-level (not Redux) because flipping it must not
 * trigger subscriber re-renders.
 */
let lastOwner: 'editor' | 'casual' | null = null

export const markStateOwnedByFullEditor = () => {
  lastOwner = 'editor'
}

export const markStateOwnedByCasual = () => {
  lastOwner = 'casual'
}

export const isStateOwnedByFullEditor = () => lastOwner === 'editor'
